module.exports = __webpack_public_path__ + "files/7c66ab879e43dc4cee493d85aa2634a3.png";